export default (name) => {
    const decodedUrl = decodeURIComponent(name)
        , arr_path = decodedUrl.split('/')
        , file_name = arr_path[arr_path.length - 1]
        , file_name_arr = file_name.split('_')
        , new_name = file_name.replace('_' + file_name_arr[file_name_arr.length - 1].split('.')[0], "")
    return new_name
}